<template>
  <page-layout-full :page-title="$t('generalTitle')">
    <p-alert
      class="identity-card__error"
      type="error"
    >
      <p>{{ $t('noCookiesMessage') }}</p>
      <p><a href="https://www.mijnpgb.nl/cookies">{{ $t('readMore') }}</a></p>
      <p>Heeft u het gebruik van cookies voor het PGB Portaal toegestaan? Druk dan op onderstaande knop om in te loggen.</p>
      <p-button
        @click="handleLoginMainPageClick"
        preset="outlined"
        id="loginButton"
      >
        {{ $t('budgethouderLink') }}
      </p-button>
    </p-alert>
    <p-row class="mt-12">
      <p-col class="d-flex justify-center">
        <router-link
          class="text-center"
          :to="{name: 'cookiemelding'}"
          @click.native.prevent="handleLoginEmployeesClick()"
          id="loginButtonMedewerker"
        >
          {{ $t('employeesLink') }}
        </router-link>
      </p-col>
    </p-row>
  </page-layout-full>
</template>

<script>
import { useRouter } from 'phoenix'
import { defineComponent } from '@vue/composition-api'
import i18n from './i18n'
import { PageCookie } from '@/composables/usePageCookie'

export default defineComponent({
  name: 'CookiesDisabled',
  i18n,
  setup () {
    const { router } = useRouter()

    const areCookiesDisabled = () => {
      const pageCookie = new PageCookie()
      return navigator.cookieEnabled === false || pageCookie.isEnabled() === false
    }

    const handleLoginMainPageClick = () => {
      if (!areCookiesDisabled()) {
        router.push({ name: 'LoginMain' })
      }
    }

    const handleLoginEmployeesClick = () => {
      if (!areCookiesDisabled()) {
        router.push({ name: 'LoginEmployees' })
      }
    }

    return {
      toPreviousPageRoute: () => { router.go(-1) },
      toHomepageRoute: () => { router.push({ name: 'LoginMain' }) },
      handleLoginMainPageClick,
      handleLoginEmployeesClick,
    }
  },
})
</script>
